/** @format */

import React, {useEffect, useState} from 'react';
import SuperAgent from 'superagent';
import {SHAPE_CARTON_AUTOLOCK, SHAPE_CARTON_STRAIGHT_TUCK} from 'frontier-constants';

export default function useSizeSpecs(props) {
    const [sizeSpecs, setSizeSpecs] = useState({});

    useEffect(() => {
        loadSpecs();
    }, [props.width, props.length, props.depth, props.shapeId]);

    async function getSpecs({width, length, depth, shapeId}) {
        const {
            body: {
                flatWidth,
                flatHeight,
                cellsAcross,
                cellsAround,
                nestedSavings,
                isGlueFlapParallelToLeadingEdge,
                ...body
            }
        } = await SuperAgent.post('/api/orders/calculate-specs')
            .set('accept', 'application/json')
            .query({XDEBUG_SESSION_START: 'PHPSTORM'})
            .send({
                width,
                length,
                depth,
                shapeId
            });

        return {
            flatWidth,
            flatHeight,
            cellsAcross,
            cellsAround,
            nestedSavings,
            isGlueFlapParallelToLeadingEdge
        };
    }
    async function loadSpecs() {
        if ([SHAPE_CARTON_AUTOLOCK, SHAPE_CARTON_STRAIGHT_TUCK].indexOf(props.shapeId) > -1) {
            const {
                flatWidth,
                flatHeight,
                cellsAcross,
                cellsAround,
                nestedSavings,
                isGlueFlapParallelToLeadingEdge
            } = await getSpecs({
                width: props.width,
                length: props.length,
                depth: props.depth,
                shapeId: props.shapeId
            });

            setSizeSpecs({
                flatWidth,
                flatHeight,
                nestedSavings,
                isGlueFlapParallelToLeadingEdge
            });
        }
    }

    return {
        ...sizeSpecs
    };
}
